import {
    ActionList,
    Badge,
    Banner,
    Button,
    ButtonGroup,
    FormLayout,
    Icon,
    Popover,
    SkeletonBodyText,
    SkeletonDisplayText,
    SkeletonThumbnail,
    Tabs,
    TextField,
    Tooltip,
} from "@shopify/polaris";
import styles from "./FormPreviewWrapper.module.css";
import { Dispatch, FormEvent, ReactNode, SetStateAction, useCallback, useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { DISCARD_BUTTON_CLICKED, getBundleRoute, getBundleType, getProductId } from "../../apps/constants";
import {
    ArrowLeftIcon,
    DuplicateIcon,
    StatusActiveIcon,
    MenuHorizontalIcon,
    ViewIcon,
    DesktopIcon,
    MobileIcon,
} from "@shopify/polaris-icons";
import { getBoolean, scrollToTop } from "../../utilities/functions";
import { FormError } from "@shopify/react-form";
import CustomModal from "../CustomModal/CustomModal";
import { endPoints, getData, postData } from "../../utilities/networkCalls";
import { SaveBar } from "@shopify/app-bridge-react";
import {
    BxgyConfigInterface,
    ChangeEvents,
    FBTConfigInterface,
    MixMatchConfigInterface,
    MixMatchSectionalConfigInterface,
    ProductAddonsConfigInterface,
    ProductAddonsPopupConfigInterface,
    StandardConfigInterface,
    VolumeConfigInterface,
    BuyNConfigInterface,
    ProductObj,
} from "../../apps/Bundles/Types";
import RenderError from "../RenderError/RenderError";
import {
    AvailableFBTTemplates,
    BundleTypes,
    fetchCollectionProducts,
    generateRandomUniqueId,
    generateSwatchConfigsFromProductMap,
    isBundleExpired,
    isBundleScheduled,
} from "../../apps/Bundles/constants";
import useBundleMixpanelHook from "../../hooks/useBundleMixpanelHook";
import SuggestFeature from "../SuggestFeature/SuggestFeature";
import ActivateSnippetModal from "../ActivateSnippetModal/ActivateSnippetModal";
import ShowOnStoreModal from "../ShowOnStoreModal/ShowOnStoreModal";
import { AppsContext } from "../../apps/Bundles/BundlesHomePage";
import LimitReachedPopup from "../Plans/LimitReachedPopup";
import VolumeBundleTemplate from "../VolumeBundleTemplate/VolumeBundleTemplate";
import StandardBundleTemplate from "../StandardBundleTemplate/StandardBundleTemplate";
import BXGYBundleTemplate from "../BXGYBundleTemplate/BXGYBundleTemplate";
import { AppConfigContext } from "../../context/AppConfigContext";
import useIsMobile from "../../hooks/useIsMobile";
import FBTBundleTemplate from "../FBTBundleTemplate/FBTBundleTemplate";
import BundleAsProductError from "../BundleAsProductError/BundleAsProductError";
import FBTModalPreviewer from "./FBTModalPreviewer";
import CalloutNudgeBanner from "../CalloutNudgeBanner";
import InfoIconOverride from "../Icons/InfoIconOverride";
import { usePlatform } from "../../hooks/usePlatform";
import { MdOutlineKeyboardCommandKey } from "react-icons/md";

type Props_FormPreviewWrapper = {
    bundleType: string;
    disabledTabs?: boolean;
    renderForms: ReactNode[];
    renderPreview: ReactNode;
    bundleConfig:
        | StandardConfigInterface
        | VolumeConfigInterface
        | BxgyConfigInterface
        | MixMatchConfigInterface
        | MixMatchSectionalConfigInterface
        | FBTConfigInterface
        | ProductAddonsConfigInterface
        | ProductAddonsPopupConfigInterface
        | BuyNConfigInterface;

    oldBundleConfig:
        | StandardConfigInterface
        | VolumeConfigInterface
        | BxgyConfigInterface
        | MixMatchConfigInterface
        | MixMatchSectionalConfigInterface
        | FBTConfigInterface
        | ProductAddonsConfigInterface
        | ProductAddonsPopupConfigInterface
        | BuyNConfigInterface;
    dispatchBundleConfig: Dispatch<any>;
    loading: boolean;
    globalErrors: FormError[];
    globalDirty: boolean;
    selected: number;
    handleNext: any;
    setConfig: Dispatch<SetStateAction<any>>;
    validateForm: () => FormError[];
    submitForm: (event?: FormEvent) => Promise<void>;
    fetchBundle: (id?: string | null) => Promise<void>;
    currentActiveProduct?: string;
    setCurrentActiveProduct?: Dispatch<React.SetStateAction<string>>;
    forAiBundle?: boolean;
    formPreviewWrapperRef?: any;
    onlyPreview?: boolean;
    _setSavingBundle?: any;
    resetForm?: any;
    collectionProducts?: ProductObj[];
    loadingCollectionProducts?: boolean;
    setSelected: Dispatch<SetStateAction<number>>;
    setHighlightedKey?: Dispatch<React.SetStateAction<string | null>>;
    highlightedKey?: string | null;
    setInspectorMode?: Dispatch<React.SetStateAction<boolean>>;
    inspectorMode?: boolean;
};

const tabs = [
    {
        id: "Content-1",
        content: "Content",
        panelID: "Content-1",
    },
    {
        id: "Design-1",
        content: "Design",
        panelID: "Design-1",
    },

    {
        id: "Target-1",
        content: "Advanced",
        panelID: "Target-1",
    },
    // {
    //     id: "Settings-1",
    //     // content: "Settings",
    //     content: (
    //         <span style={{ display: "flex", alignItems: "center" }}>
    //             Settings
    //             <span
    //                 style={{
    //                     backgroundColor: "#FFECB3",
    //                     color: "#FF6F00",
    //                     borderRadius: "12px",
    //                     padding: "0px 4px",
    //                     marginLeft: "4px",
    //                     fontSize: "7px",

    //                     position: "absolute",
    //                     top: "1px",
    //                     right: "-48px",
    //                 }}
    //             >
    //                 Coming Soon
    //             </span>
    //         </span>
    //     ) as unknown as string,

    //     panelID: "Settings-1",
    //     disabled: true,
    // },
];

export const FormLoadingSkeleton = () => {
    return (
        <div style={{ paddingLeft: "13px" }}>
            <div style={{ marginTop: "10px" }}>
                <div
                    style={{
                        width: "55%",
                        marginBottom: "7px",
                    }}
                >
                    <SkeletonBodyText lines={1} />
                </div>
                <SkeletonDisplayText maxWidth={`${50}%`} />
            </div>
            <div style={{ marginTop: "10px" }}>
                <div
                    style={{
                        width: "55%",
                        marginBottom: "7px",
                    }}
                >
                    <SkeletonBodyText lines={1} />
                </div>
                <SkeletonDisplayText maxWidth={`${50}%`} />
            </div>
            <div style={{ marginTop: "10px" }}>
                <div
                    style={{
                        width: "55%",
                        marginBottom: "7px",
                    }}
                >
                    <SkeletonBodyText lines={1} />
                </div>
                <SkeletonDisplayText maxWidth={`${50}%`} />
            </div>
            <div style={{ marginTop: "10px" }}>
                <div
                    style={{
                        width: "55%",
                        marginBottom: "7px",
                    }}
                >
                    <SkeletonBodyText lines={1} />
                </div>
                <SkeletonDisplayText maxWidth={`${50}%`} />
            </div>
            <div style={{ marginTop: "10px" }}>
                <div
                    style={{
                        width: "55%",
                        marginBottom: "7px",
                    }}
                >
                    <SkeletonBodyText lines={1} />
                </div>
                <SkeletonDisplayText maxWidth={`${50}%`} />
            </div>
        </div>
    );
};

export const PreviewLoadingSkeleton = () => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                backgroundColor: "white",
                padding: "10px",
                borderRadius: "12px",
            }}
        >
            <div style={{ margin: "0 auto 10px auto" }}>
                <div
                    style={{
                        width: "150px",
                        textAlign: "center",
                    }}
                >
                    <SkeletonDisplayText maxWidth={`${100}%`} />
                </div>
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
                <div style={{ width: "30px", marginRight: "10px" }}>
                    <SkeletonThumbnail size={"small"} />
                </div>
                <div
                    style={{
                        width: "700px",
                        marginBottom: "7px",
                        marginRight: "80px",
                    }}
                >
                    <SkeletonDisplayText maxWidth={`${100}%`} />
                </div>
                <SkeletonBodyText lines={2} />
            </div>

            <div
                style={{
                    textAlign: "center",
                    margin: "12px 0",
                    fontSize: "16px",
                    color: "#e3e3e3",
                }}
            >
                +
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
                <div style={{ width: "30px", marginRight: "10px" }}>
                    <SkeletonThumbnail size={"small"} />
                </div>
                <div
                    style={{
                        width: "700px",
                        marginBottom: "20px",
                        marginRight: "80px",
                    }}
                >
                    <SkeletonDisplayText maxWidth={`${100}%`} />
                </div>
                <SkeletonBodyText lines={2} />
            </div>

            <div style={{ display: "flex", marginTop: "10px" }}>
                <div
                    style={{
                        width: "100%",
                    }}
                >
                    <SkeletonDisplayText maxWidth={`${100}%`} />
                </div>
            </div>
        </div>
    );
};

const FormPreviewWrapper = ({
    bundleType,
    disabledTabs = false,
    renderForms,
    renderPreview,
    bundleConfig,
    oldBundleConfig,
    loading = false,
    globalErrors,
    globalDirty,
    selected,
    handleNext,
    dispatchBundleConfig,
    setConfig,
    validateForm,
    submitForm,
    currentActiveProduct,
    setCurrentActiveProduct,
    forAiBundle,
    formPreviewWrapperRef,
    onlyPreview,
    _setSavingBundle = () => {},
    resetForm = () => {},
    setSelected,
    inspectorMode = false,
    setInspectorMode = () => {},
    collectionProducts = [],
    loadingCollectionProducts = false,
}: Props_FormPreviewWrapper) => {
    // console._log("bundleConfig ====", bundleConfig);
    const [selectedPreviewView, setSelectedPreviewView] = useState(1);
    const [showLimitPopup, setShowLimitPopup] = useState(false);

    const goTo = useNavigate();
    const [activatingBundle, setActivatingBundle] = useState(false);
    const [savingBundle, setSavingBundle] = useState(false);
    const { publishCount, setPublishCount } = useContext(AppsContext);
    const { plansInfo, globalSettingsInfo, sft } = useContext(AppConfigContext);
    const { isExhausted, currentPlan, currentOrders, isTrial } = plansInfo;
    const [duplicateConfirmModal, setDuplicateConfirmModal] = useState(false);
    const [newBundleTitle, setNewBundleTitle] = useState("");
    const [duplicateErr] = useState("");
    const [duplicatingBundle, setDuplicatingBundle] = useState(false);
    const [duplicateBundleLoading, setDuplicateBundleLoading] = useState(false);
    const [showStoreModal, setShowStoreModal] = useState<boolean>(false);
    const [previewLink, setPreviewLink] = useState("");
    const [active, setActive] = useState(false);
    const [showPostPublishModal, setShowPostPublishModal] = useState(false);
    const { isMobile } = useIsMobile();

    const platform = usePlatform();
    // console._log(setIsMobile);
    console._log("dirtytest:::::::::::::::::", globalDirty);

    useEffect(() => {
        if (!loading) {
            // @ts-expect-error hack
            setPublishCount(bundleConfig.publish_count || 0);
        }
    }, [loading]);

    useEffect(() => {
        if (!currentPlan || Object.keys(currentPlan).length === 0) {
            handleRedirectToPlan();
        }
    }, [currentPlan]);

    const handleRedirectToPlan = () => {
        goTo("/billing");
    };

    const { trackFormMenu, trackErrorBeforeSave, trackInspectorModeToggle } = useBundleMixpanelHook();

    const handleInspectorToggle = () => {
        if (loading) return;
        const newMode = !inspectorMode;

        setInspectorMode(newMode);

        trackInspectorModeToggle({
            bundleType: bundleConfig?.bundle_type || "",
            ctaType: "Toggle Inspector",
            cta: "Inspector Mode Toggle",
            inspectorMode: newMode,
        });
    };

    useEffect(() => {
        if (globalDirty) {
            shopify.saveBar.show("bundle-save-bar");
        } else {
            shopify.saveBar.hide("bundle-save-bar");
        }
    }, [globalDirty]);

    useEffect(() => {
        if (formPreviewWrapperRef)
            formPreviewWrapperRef.current = {
                handleBundleSave,
                loader: savingBundle,
                disabled: savingBundle || activatingBundle || loading,
            };
    }, [bundleConfig, savingBundle, activatingBundle, loading]);

    const handleTabChange = useCallback((selectedTabIndex: number) => {
        handleNext(selectedTabIndex, tabs[selectedTabIndex]?.content);
    }, []);

    const handleBundleSave = async (param = { src: "Form Menu" }) => {
        console._log("oldconfig", oldBundleConfig);

        submitForm();

        if (validateForm().length) {
            try {
                const errors = validateForm()
                    .map((err, idx) => `${idx + 1}. ${err.message}`)
                    .join("\n");

                trackErrorBeforeSave({
                    ctaType: "Save",
                    cta: param?.src || "-",
                    bundleType: bundleConfig?.bundle_type || "",
                    errors,
                });
            } catch (error) {
                console._log("something went wrong");
            }
            scrollToTop();
            return;
        }

        trackFormMenu({
            ctaType: "Save",
            cta: param?.src || "-",
            bundleType: bundleConfig?.bundle_type || "",
        });

        setSavingBundle(true);
        if (!bundleConfig?.form_id) {
            setInspectorMode(false);
        }

        let updatedBundleConfig = { ...bundleConfig };

        // 👇 existing bundle type cleanup
        if (bundleConfig.bundle_type === "standard") {
            updatedBundleConfig = {
                ...(bundleConfig as StandardConfigInterface),
                bundle_as_product: {
                    ...(bundleConfig as StandardConfigInterface).bundle_as_product,
                    images:
                        (bundleConfig as StandardConfigInterface)?.bundle_as_product?.images?.filter(
                            (ps: any) => !!ps?.originalSource?.length,
                        ) || [],
                    show_on_product_page:
                        (bundleConfig as StandardConfigInterface)?.bundle_as_product?.show_on_product_page ?? [],
                },
            };
        }

        if (bundleConfig.bundle_type === "volume") {
            updatedBundleConfig = {
                ...(bundleConfig as VolumeConfigInterface),
                volume_discounts: bundleConfig.volume_discounts.map((vd) => ({
                    ...vd,
                    discount_value: parseFloat(vd.discount_value) || 0,
                })),
            };
        }

        if (bundleConfig.bundle_type === "mixmatch" || bundleConfig.bundle_type === "mixmatch_sectional") {
            updatedBundleConfig = {
                ...(bundleConfig as MixMatchConfigInterface),
                // @ts-expect-error hack
                discount_options: bundleConfig?.discount_options?.map((vd: any) => ({
                    ...vd,
                    discountValue: parseFloat(vd.discountValue) || 0,
                })),
            };
        }
        if (bundleConfig.bundle_type === "mixmatch_sectional" || bundleConfig.bundle_type == "mixmatch") {
            updatedBundleConfig = {
                ...(bundleConfig as MixMatchSectionalConfigInterface),
                // @ts-expect-error hack
                discount_options: bundleConfig?.discount_options?.map((vd: any) => ({
                    ...vd,
                    discountValue: parseFloat(vd.discountValue) || 0,
                })),
                ...((bundleConfig as MixMatchSectionalConfigInterface)?.bundle_as_product?.images?.length && {
                    bundle_as_product: {
                        ...(bundleConfig as MixMatchSectionalConfigInterface)?.bundle_as_product,
                        images:
                            (bundleConfig as MixMatchSectionalConfigInterface)?.bundle_as_product?.images?.filter(
                                (ps: any) => !!ps?.originalSource?.length,
                            ) || [],
                    },
                }),
            };
        }

        const res = await postData({
            url: bundleConfig?.form_id ? endPoints.updateBundle : endPoints.saveBundle,
            payload: { ...updatedBundleConfig },
        });

        // continue with UI update flow
        if (res.status === 200 || res.status === 201) {
            // Updating user_saved flag
            switch (bundleType) {
                case BundleTypes.STANDARD: {
                    globalSettingsInfo.globalSettings.design_settings_standard = {
                        ...updatedBundleConfig.bundles_design,
                        user_saved: true,
                    };
                    break;
                }
                case BundleTypes.VOLUME_DISCOUNT: {
                    globalSettingsInfo.globalSettings.design_settings_volume = {
                        ...updatedBundleConfig.bundles_design,
                        user_saved: true,
                    };
                    break;
                }
                case BundleTypes.BXGY: {
                    globalSettingsInfo.globalSettings.design_settings_bxgy = {
                        ...updatedBundleConfig.bundles_design,
                        user_saved: true,
                    };
                    // globalSettingsInfo.globalSettings.design_settings_bxgy.user_saved = true;
                    break;
                }
                case BundleTypes.BUY_N: {
                    globalSettingsInfo.globalSettings.design_settings_buy_n = {
                        ...updatedBundleConfig.bundles_design,
                        user_saved: true,
                    };
                    break;
                }
                case BundleTypes.FBT: {
                    globalSettingsInfo.globalSettings.design_settings_fbt = {
                        ...updatedBundleConfig.bundles_design,
                        user_saved: true,
                    };
                    break;
                }
                case BundleTypes.MIX_MATCH: {
                    globalSettingsInfo.globalSettings.design_settings_mixmatch = {
                        ...updatedBundleConfig.bundles_design,
                        user_saved: true,
                    };
                    break;
                }
                case BundleTypes.MIX_MATCH_SECTIONAL: {
                    globalSettingsInfo.globalSettings.design_settings_mixmatch_sectional = {
                        ...updatedBundleConfig.bundles_design,
                        user_saved: true,
                    };
                    break;
                }
                case BundleTypes.PRODUCT_ADDONS: {
                    globalSettingsInfo.globalSettings.design_settings_product_add_on = {
                        ...updatedBundleConfig.bundles_design,
                        user_saved: true,
                    };
                    break;
                }
                case BundleTypes.PRODUCT_ADDONS_POPUP: {
                    globalSettingsInfo.globalSettings.design_settings_product_add_on_popup = {
                        ...updatedBundleConfig.bundles_design,
                        user_saved: true,
                    };
                    break;
                }
                default:
                    break;
            }

            if (
                res?.data?.hasOwnProperty("product_handle") &&
                res?.data?.hasOwnProperty("product_bundle_id") &&
                (bundleConfig?.bundle_type === BundleTypes.STANDARD ||
                    bundleConfig?.bundle_type === BundleTypes.BXGY ||
                    bundleConfig?.bundle_type === BundleTypes.MIX_MATCH ||
                    bundleConfig?.bundle_type === BundleTypes.MIX_MATCH_SECTIONAL)
            ) {
                setConfig((ps: any) => ({
                    ...ps,
                    bundle_as_product: {
                        ...ps.bundle_as_product,
                        product_handle: res?.data.product_handle ?? ps?.bundle_as_product?.product_handle ?? "",
                    },
                    product_bundle_id: res?.data?.product_bundle_id,
                }));
                dispatchBundleConfig({
                    payload: {
                        product_handle: res?.data.product_handle ?? "",
                    },
                    isComplex: true,
                    key: "bundle_as_product",
                });
                dispatchBundleConfig({
                    payload: res?.data?.product_bundle_id,
                    key: "product_bundle_id",
                });
            }

            if (!bundleConfig?.form_id) {
                dispatchBundleConfig({
                    payload: res.data.data,
                    key: "form_id",
                });
                setConfig((ps: any) => ({ ...ps, form_id: res.data.data }));
            } else {
                setConfig({ ...bundleConfig });
            }

            shopify.saveBar.hide("bundle-save-bar");

            if (!forAiBundle) {
                goTo(getBundleRoute(bundleType, res.data.data || bundleConfig?.form_id));
            }

            shopify.toast.show("Data saved successfully.", {
                isError: false,
                duration: 1500,
            });

            // --- metafield update done AFTER save (async) ---
            // Always sync all entries from current swatchesProductsMap (no old/new comparison)
            const changedSwatches = generateSwatchConfigsFromProductMap(bundleConfig?.swatchesProductsMap || {});

            if (changedSwatches.length > 0) {
                const grouped: Record<string, any[]> = {};

                changedSwatches.forEach((item) => {
                    if (!grouped[item.productId]) grouped[item.productId] = [];
                    grouped[item.productId].push(item);
                });

                const payload = {
                    kefi_swatches: Object.values(grouped).map((group) => ({
                        options: group,
                    })),
                };

                await postData({
                    url: endPoints.updateSwatchesMeta,
                    payload,
                });
            }
        } else {
            let finalMessage = "Failed to save data. Please try again.";
            const rawError = res?.data?.message;
            // Only run this logic when backend sends a string that contains a JSON object
            if (typeof rawError === "string" && rawError.includes('"message"')) {
                try {
                    const parsed = JSON.parse(rawError);
                    // Only override when parsed.message actually exists
                    if (
                        parsed &&
                        typeof parsed === "object" &&
                        typeof parsed.message === "string" &&
                        parsed.message.toLowerCase().includes("handle") &&
                        parsed.message.toLowerCase().includes("already in use")
                    ) {
                        finalMessage = parsed.message.trim();
                    }
                } catch (_) {
                    // If parse fails, keep default message
                }
            }
            shopify.toast.show(finalMessage, {
                isError: true,
                duration: 2000,
            });
        }

        _setSavingBundle(false);
        setSavingBundle(false);
    };

    const handleActivate = async (currentStatus: boolean, form_id = "") => {
        if (!isTrial && isExhausted && !currentStatus) {
            setShowLimitPopup(true);
            return;
        }
        if (!form_id) {
            return;
        }
        setActivatingBundle(true);
        // console._log(activatingBundle);
        trackFormMenu({
            cta: "Form Menu",
            ctaType: currentStatus ? "Deactivating" : "Activating",
            bundleType: bundleConfig?.bundle_type || "",
        });
        try {
            if (!currentStatus) {
                const isExtensionEnabled = await getData({
                    url: endPoints.extensionStatus,
                });
                if (isExtensionEnabled.data.status == 0) {
                    setShowEnableCoreSnippetModal(true);
                    return;
                }
            }

            const res = await postData({
                url: endPoints.updateBundleStatus,
                payload: {
                    form_id: form_id,
                    status: !currentStatus,
                    delete: false,
                },
            });

            if (res.status === 200 || res.status === 201) {
                if (!currentStatus && publishCount != null && publishCount == 0) {
                    setShowPostPublishModal(true);
                }
                dispatchBundleConfig({
                    payload: currentStatus ? false : true,
                    key: "status",
                });

                shopify.toast.show("Bundle status updated successfully!", {
                    isError: false,
                });
            } else {
                shopify.toast.show("Failed to update bundle status. Please try again.", {
                    isError: true,
                });
            }
        } catch (error) {
            shopify.toast.show("An error occurred while updating bundle status. Please try again.", {
                isError: true,
            });
        } finally {
            setActivatingBundle(false);
            setActive(false);
        }
    };

    const handleDuplicate = async (name = "") => {
        setDuplicateBundleLoading(true);

        if (!name) {
            setDuplicateConfirmModal(true);
            setDuplicateBundleLoading(false);
            return;
        }
        trackFormMenu({
            cta: "Form Menu",
            ctaType: "Duplicate Bundle",
            bundleType: bundleConfig?.bundle_type || "",
        });
        setDuplicatingBundle(true);

        try {
            const res = await postData({
                url: endPoints.saveBundle,
                payload: {
                    ...bundleConfig,
                    title: name,
                    offer_name: "",
                    bundle_embed_id: generateRandomUniqueId(),
                    ...((bundleConfig.bundle_type === BundleTypes.STANDARD ||
                        bundleConfig.bundle_type === BundleTypes.BXGY ||
                        bundleConfig.bundle_type === BundleTypes.MIX_MATCH ||
                        bundleConfig.bundle_type === BundleTypes.MIX_MATCH_SECTIONAL) && {
                        bundle_as_product: {
                            // @ts-expect-error hack
                            ...bundleConfig.bundle_as_product,
                            product_title: name,
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-expect-error
                            images: bundleConfig.bundle_as_product.images.map((image: any) => {
                                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                                const { id, altText, ...rest } = image;
                                return {
                                    ...rest,
                                    mediaContentType: "IMAGE",
                                };
                            }),
                        },
                    }),
                },
            });

            if (res.status === 200) {
                shopify.toast.show("Bundle duplicated successfully", {
                    isError: false,
                });
                setDuplicateConfirmModal(false);
                if (res?.data?.data) {
                    goTo(getBundleRoute(bundleConfig.bundle_type, res.data?.data));
                }
            } else if (res.status === 400) {
                shopify.toast.show("Error duplicating bundle", {
                    isError: true,
                });
            }
        } catch (error) {
            shopify.toast.show("An unexpected error occurred", {
                isError: true,
            });
        } finally {
            setDuplicatingBundle(false);
            setDuplicateBundleLoading(false);
            setNewBundleTitle("");
        }
    };

    const handleStoreModalDisplay = (link = "") => {
        // Check if we need to show the modal
        const countKey = `bundle_settings_${bundleType}`;
        const settingsObj = globalSettingsInfo?.globalSettings?.[countKey];
        if (settingsObj?.show_on_store_modal_count === 0) {
            if (link) setPreviewLink(link);
            setShowStoreModal(true);
            postData({
                url: endPoints.updateBundleSettings,
                payload: {
                    bundle_type: bundleType,
                    bundles_settings: {
                        show_on_store_modal_count: 1,
                    },
                },
            });
            // Update local context so it doesn't trigger again
            settingsObj.show_on_store_modal_count = 1;
        }
    };

    const getPreviewUrl = (): string => {
        let previewUrl = "";
        const shopBase = `https://${shopify.config.shop}`;
        trackFormMenu({
            cta: "Form Menu",
            ctaType: "Show on Store",
            bundleType: bundleConfig?.bundle_type || "",
        });
        if (bundleType === BundleTypes.STANDARD || bundleType === BundleTypes.BXGY) {
            const cfg = bundleConfig as StandardConfigInterface | BxgyConfigInterface;

            const handler = cfg.isProductPageVisible
                ? cfg.bundle_as_product.product_handle
                : cfg.products[0]?.handle || "";

            if (shopify.config.shop) {
                previewUrl = `${shopBase}/products/${handler}`;
            }
        } else if (bundleType === BundleTypes.FBT) {
            const handler = window.localStorage.getItem("fbt_handle");
            if (shopify.config.shop) {
                previewUrl = `${shopBase}/products/${handler}`;
            }
        } else if (bundleType == BundleTypes.PRODUCT_ADDONS) {
            // @ts-expect-error hack
            if (bundleConfig?.product_add_on_selection === "collection") {
                // @ts-expect-error hack
                if (bundleConfig?.collections?.length > 0) {
                    // @ts-expect-error hack
                    const collection = bundleConfig.collections[0]; // Assuming we pick the first collection
                    const collectionName = collection.title.replace(/\s+/g, "-").toLowerCase(); // Convert title to URL-friendly format

                    if (collectionName) {
                        return `${shopBase}/collections/${collectionName}`;
                    }
                }
            }
            const handler = window.localStorage.getItem("addons_handle");
            let variantId = "";
            if (bundleConfig?.same_addon_for_all_variants === false) {
                if (bundleConfig?.products?.length > 0) {
                    const firstProduct = bundleConfig.products[0];
                    if (firstProduct?.variants?.length > 0) {
                        const vId = firstProduct.variants[0].id;
                        variantId = getProductId(vId);
                    }
                }
            }
            if (shopify.config.shop) {
                previewUrl = `${shopBase}/products/${handler}`;
                if (variantId) {
                    previewUrl += `?variant=${variantId}`;
                }
            }
        } else if (bundleType == BundleTypes.MIX_MATCH) {
            if ("isProductPageVisible" in bundleConfig && bundleConfig?.isProductPageVisible) {
                const handler = bundleConfig?.bundle_as_product?.product_handle || "";
                if (shopify.config.shop && handler) {
                    previewUrl = `${shopBase}/products/${handler}`;
                }
            }
            // @ts-expect-error hack
            else if (bundleConfig?.mixmatch_product_selection === "collection") {
                const mmHandle = window.localStorage.getItem("mm_handle");

                if (mmHandle) {
                    previewUrl = `${shopBase}/products/${mmHandle}`;
                }
            } else {
                const handler = bundleConfig.products[0]?.handle || "";
                if (shopify.config.shop) {
                    previewUrl = `${shopBase}/products/${handler}`;
                }
            }
        } else if (bundleType == BundleTypes.BUY_N) {
            // @ts-expect-error hack
            if (bundleConfig?.product_selection_type === "collection") {
                const mmHandle = window.localStorage.getItem("buy_n_handle");

                if (mmHandle) {
                    previewUrl = `${shopBase}/products/${mmHandle}`;
                }
            } else {
                const handler = bundleConfig.products[0]?.handle || "";
                if (shopify.config.shop) {
                    previewUrl = `${shopBase}/products/${handler}`;
                }
            }
        } else if (bundleType == BundleTypes.MIX_MATCH_SECTIONAL) {
            // @ts-expect-error required
            const firstSection = bundleConfig?.mix_match_sections?.[0]; // get first section
            if ("isProductPageVisible" in bundleConfig && bundleConfig?.isProductPageVisible) {
                const handler = bundleConfig?.bundle_as_product?.product_handle || "";
                if (shopify.config.shop && handler) {
                    previewUrl = `${shopBase}/products/${handler}`;
                }
            } else if (firstSection?.product_selection === "collection") {
                const mmSectionalHandle = window.localStorage.getItem("mm_s_handle");
                if (mmSectionalHandle) {
                    previewUrl = `${shopBase}/products/${mmSectionalHandle}`;
                }
            } else {
                const handler = firstSection?.products?.[0]?.handle || "";
                if (shopify.config.shop && handler) {
                    previewUrl = `${shopBase}/products/${handler}`;
                }
            }
        } else if (
            bundleType == BundleTypes.VOLUME_DISCOUNT &&
            // @ts-expect-error hack
            bundleConfig?.volume_product_selection === "collection"
        ) {
            // @ts-expect-error hack
            if (bundleConfig?.collections?.length > 0) {
                // @ts-expect-error hack
                const collection = bundleConfig.collections[0];
                const collectionName = collection.title.replace(/\s+/g, "-").toLowerCase();

                if (collectionName) {
                    return `${shopBase}/collections/${collectionName}`;
                }
            }
            const handler = window.localStorage.getItem("qb_handle");
            if (shopify.config.shop) {
                previewUrl = `${shopBase}/products/${handler}`;
            }
        } else if (
            bundleType == BundleTypes.VOLUME_DISCOUNT &&
            // @ts-expect-error hack
            bundleConfig?.volume_product_selection != "specific"
        ) {
            const handler = window.localStorage.getItem("qb_handle");
            if (shopify.config.shop) {
                previewUrl = `${shopBase}/products/${handler}`;
            }
        } else {
            const handler = bundleConfig.products[0]?.handle || "";
            if (shopify.config.shop) {
                previewUrl = `${shopBase}/products/${handler}`;
            }
        }
        return previewUrl;
    };

    const handlePreview = () => {
        const url = getPreviewUrl();
        handleStoreModalDisplay(url);
        window.open(url, "_blank");
    };

    const [previewBtnLoading, setPreviewBtnLoading] = useState<boolean>(false);
    const [showEnableCoreSnippetModalForDraftPreview, setShowEnableCoreSnippetModalForDraftPreview] =
        useState<boolean>(false);
    const handleDraftPreview = async () => {
        setPreviewBtnLoading(true);
        const isExtensionEnabled = await getData({
            url: endPoints.extensionStatus,
        });
        if (isExtensionEnabled.data.status == 0) {
            setPreviewBtnLoading(false);
            setShowEnableCoreSnippetModalForDraftPreview(true);
            return;
        }

        const fId = bundleConfig?.form_id;
        if (bundleType === BundleTypes.STANDARD || bundleType === BundleTypes.BXGY) {
            const cfg = bundleConfig as StandardConfigInterface | BxgyConfigInterface;

            const handler = cfg.isProductPageVisible
                ? cfg.bundle_as_product.product_handle
                : cfg.products[0]?.handle || "";

            if (shopify.config.shop) {
                window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
            }
        } else if (bundleType == BundleTypes.FBT) {
            const handler = window.localStorage.getItem("fbt_handle");
            if (shopify.config.shop) {
                window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
            }
        } else if (bundleType == BundleTypes.PRODUCT_ADDONS) {
            // @ts-expect-error hack
            if (bundleConfig?.product_add_on_selection === "collection") {
                // @ts-expect-error hack
                if (bundleConfig?.collections?.length > 0) {
                    // @ts-expect-error hack
                    const collection = bundleConfig.collections[0];
                    const { products } = await fetchCollectionProducts(
                        collection.id.split("/").pop(),
                        sft,
                        () => {},
                        false,
                        1,
                    );
                    const handler = products[0]?.handle;
                    if (shopify.config.shop && handler) {
                        window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
                    }
                }
            }
            const handler = window.localStorage.getItem("addons_handle");
            let variantId = "";
            if (bundleConfig?.same_addon_for_all_variants === false) {
                if (bundleConfig?.products?.length > 0) {
                    const firstVariantWithAddons = Object.entries(bundleConfig?.variant_addons)?.find(
                        ([key, value]: any) => {
                            if (value && value.length > 0) return key;
                        },
                    );
                    if (firstVariantWithAddons) {
                        variantId = getProductId(firstVariantWithAddons[0] || "");
                    }
                }
            }
            if (shopify.config.shop) {
                let url = `https://${shopify.config.shop}/products/${handler}?form_id=${fId}`;
                if (variantId) {
                    url += `&variant=${variantId}`;
                }
                window.open(url, "_blank");
            }
        } else if (bundleType == BundleTypes.PRODUCT_ADDONS_POPUP) {
            // @ts-expect-error hack
            if (bundleConfig?.product_add_on_selection === "collection") {
                // @ts-expect-error hack
                if (bundleConfig?.collections?.length > 0) {
                    // @ts-expect-error hack
                    const collection = bundleConfig.collections[0];
                    const { products } = await fetchCollectionProducts(
                        collection.id.split("/").pop(),
                        sft,
                        () => {},
                        false,
                        1,
                    );
                    const handler = products[0]?.handle;
                    if (shopify.config.shop && handler) {
                        window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
                    }
                }
            }
            const handler = window.localStorage.getItem("addons_popup_handle");
            if (shopify.config.shop) {
                window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
            }
        } else if (bundleType == BundleTypes.MIX_MATCH) {
            if ("isProductPageVisible" in bundleConfig && bundleConfig?.isProductPageVisible) {
                const handler = bundleConfig?.bundle_as_product?.product_handle || "";
                if (shopify.config.shop && handler) {
                    window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
                }
            }
            // @ts-expect-error hack
            else if (bundleConfig?.mixmatch_product_selection === "collection") {
                const mmHandle = window.localStorage.getItem("mm_handle");

                if (mmHandle) {
                    window.open(`https://${shopify.config.shop}/products/${mmHandle}?form_id=${fId}`, "_blank");
                }
            } else {
                const handler = bundleConfig.products[0]?.handle || "";
                if (shopify.config.shop) {
                    window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
                }
            }
        } else if (bundleType == BundleTypes.BUY_N) {
            // @ts-expect-error hack
            if (bundleConfig?.product_selection_type === "collection") {
                const mmHandle = window.localStorage.getItem("buy_n_handle");

                if (mmHandle) {
                    window.open(`https://${shopify.config.shop}/products/${mmHandle}?form_id=${fId}`, "_blank");
                }
            } else {
                const handler = bundleConfig.products[0]?.handle || "";
                if (shopify.config.shop) {
                    window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
                }
            }
        } else if (bundleType == BundleTypes.MIX_MATCH_SECTIONAL) {
            // @ts-expect-error required
            const firstSection = bundleConfig?.mix_match_sections?.[0]; // get first section
            if ("isProductPageVisible" in bundleConfig && bundleConfig?.isProductPageVisible) {
                const handler = bundleConfig?.bundle_as_product?.product_handle || "";
                if (shopify.config.shop && handler) {
                    window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
                }
            } else if (firstSection?.product_selection === "collection") {
                const mmSectionalHandle = window.localStorage.getItem("mm_s_handle");
                if (mmSectionalHandle) {
                    window.open(
                        `https://${shopify.config.shop}/products/${mmSectionalHandle}?form_id=${fId}`,
                        "_blank",
                    );
                }
            } else {
                const handler = firstSection?.products?.[0]?.handle || "";
                if (shopify.config.shop && handler) {
                    window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
                }
            }
        } else if (
            bundleType == BundleTypes.VOLUME_DISCOUNT &&
            // @ts-expect-error hack
            bundleConfig?.volume_product_selection === "collection"
        ) {
            // @ts-expect-error hack
            if (bundleConfig?.collections?.length > 0) {
                // @ts-expect-error hack
                const collection = bundleConfig.collections[0];
                const { products } = await fetchCollectionProducts(
                    collection.id.split("/").pop(),
                    sft,
                    () => {},
                    false,
                    1,
                );
                const handler = products[0]?.handle;
                if (shopify.config.shop && handler) {
                    window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
                }
            }
        } else if (
            bundleType == BundleTypes.VOLUME_DISCOUNT &&
            // @ts-expect-error hack
            bundleConfig?.volume_product_selection != "specific"
        ) {
            const handler = window.localStorage.getItem("qb_handle");
            if (shopify.config.shop) {
                window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
            }
        } else {
            const handler = bundleConfig.products[0]?.handle || "";
            if (shopify.config.shop) {
                window.open(`https://${shopify.config.shop}/products/${handler}?form_id=${fId}`, "_blank");
            }
        }
        setPreviewBtnLoading(false);
    };

    const handleDiscard = (param = { src: "Top Bar" }) => {
        trackFormMenu({
            cta: param?.src || "-",
            ctaType: "Discard",
            bundleType: bundleConfig?.bundle_type || "",
        });
        window.dispatchEvent(
            new CustomEvent(DISCARD_BUTTON_CLICKED, {
                detail: {},
            }),
        );
        resetForm();
        dispatchBundleConfig({
            type: ChangeEvents.initState,
            init: { ...oldBundleConfig },
        });
        shopify.saveBar.hide("bundle-save-bar");
        setSelected(0);
    };

    const getTooltipContent = () => {
        if (globalDirty) {
            return (
                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <img
                        src={"/svgs/upArrow.png"}
                        alt="Warning"
                        style={{ width: 25, height: 25, transform: "rotate(-20deg)" }}
                    />
                    Please save the offer first!
                </span>
            );
        }
        if (
            bundleConfig?.form_id?.length > 0 &&
            bundleConfig?.isProductPageVisible == true &&
            bundleConfig?.product_bundle_id == ""
        ) {
            return (
                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    Please restore the product first!
                </span>
            );
        }

        return "";
    };

    const tooltipContent = getTooltipContent();

    const shakeSaveBar = () => {
        const saveBar = document.getElementById("bundle-save-bar");
        if (saveBar) {
            shopify.saveBar.leaveConfirmation();
        }
    };

    const [showEnableCoreSnippetModal, setShowEnableCoreSnippetModal] = useState<boolean>(false);

    const { bId } = useParams();

    const [openVolumeTemplateModal, setOpenVolumeTemplateModal] = useState(false);
    const [openStandardTemplateModal, setOpenStandardTemplateModal] = useState(false);
    const [openBXGYTemplateModal, setOpenBXGYTemplateModal] = useState(false);
    const [openFBTTemplateModal, setOpenFBTTemplateModal] = useState(false);

    return (
        <div className={styles.formOuterWrapper} id="formPreviewWrapper">
            <div className={styles.formPreviewWrapper} key={bundleType}>
                <div
                    style={{
                        backgroundColor: forAiBundle ? "transparent" : "#f1f1f1",
                        position: "sticky",
                        top: "0",
                        zIndex: "110",
                        paddingBottom: forAiBundle ? 0 : "16px",
                    }}
                >
                    {!forAiBundle && (
                        <div className={styles.metaBarWrapper}>
                            <div className={styles.metaBarWrapperLeft}>
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        if (!globalDirty) {
                                            trackFormMenu({
                                                cta: "Form Menu",
                                                ctaType: "Back",
                                                bundleType: bundleConfig?.bundle_type || "",
                                            });
                                            goTo(
                                                bundleConfig?.form_id?.length
                                                    ? getBundleRoute(BundleTypes.OFFERS)
                                                    : getBundleRoute("/"),
                                            );
                                        } else {
                                            shopify.saveBar.leaveConfirmation();
                                        }
                                    }}
                                    className={styles.backBtn}
                                >
                                    <ArrowLeftIcon width={18} />
                                </div>
                                <span
                                    className={styles.bundleName}
                                    style={{
                                        fontSize: isMobile ? "1rem" : "",
                                    }}
                                >
                                    {bId ? `Edit ${getBundleType(bundleType)}` : `Create ${getBundleType(bundleType)}`}
                                </span>{" "}
                                {!!bundleConfig?.form_id?.length && (
                                    <>
                                        {getBoolean(bundleConfig?.status) ? (
                                            isBundleScheduled(bundleConfig.start_date) ? (
                                                <Badge tone="attention">Scheduled</Badge>
                                            ) : isBundleExpired(bundleConfig.end_date) ? (
                                                <Badge>Expired</Badge>
                                            ) : bundleConfig?.is_paused ? (
                                                <Tooltip
                                                    content={
                                                        "This offer is currently paused because you’ve reached your plan limit. Once you upgrade your plan, the offer will be published automatically"
                                                    }
                                                >
                                                    <Badge tone={"warning"}>Paused</Badge>
                                                </Tooltip>
                                            ) : (
                                                <Badge tone="success">Active</Badge>
                                            )
                                        ) : (
                                            <Badge tone="info">Draft</Badge>
                                        )}
                                    </>
                                )}
                            </div>

                            {/* Action buttons */}
                            <div className={styles.metaBarWrapperRight}>
                                {getBoolean(bundleConfig.status) && (
                                    <span className={`${styles.secondaryBtn} ${styles.duplicateButton}`}>
                                        <Button
                                            onClick={() => {
                                                handlePreview();
                                            }}
                                            disabled={
                                                !bundleConfig.status ||
                                                !bundleConfig?.form_id?.length ||
                                                loading ||
                                                globalDirty
                                            }
                                        >
                                            Show on Store
                                        </Button>
                                    </span>
                                )}
                                {!getBoolean(bundleConfig.status) &&
                                    (bundleConfig?.product_bundle_id == "" ||
                                        bundleConfig?.product_bundle_id == null) &&
                                    bundleConfig?.form_id?.length > 0 && (
                                        <span className={`${styles.secondaryBtn} ${styles.duplicateButton}`}>
                                            <Button
                                                onClick={() => {
                                                    handleDraftPreview();
                                                }}
                                                disabled={!bundleConfig?.form_id?.length || loading || globalDirty}
                                                loading={previewBtnLoading}
                                            >
                                                Preview on Store
                                            </Button>
                                        </span>
                                    )}
                                <span className={`${styles.secondaryBtn} ${styles.duplicateButton}`}>
                                    <Button
                                        onClick={() => {
                                            trackFormMenu({
                                                cta: "Form Menu",
                                                ctaType: "Duplicate Modal Triggered",
                                                bundleType: bundleConfig?.bundle_type || "",
                                            });
                                            setDuplicateConfirmModal(true);
                                        }}
                                        disabled={
                                            !bundleConfig?.form_id?.length ||
                                            duplicatingBundle ||
                                            loading ||
                                            globalDirty
                                        }
                                    >
                                        Duplicate
                                    </Button>
                                </span>

                                {tooltipContent ? (
                                    <Tooltip content={tooltipContent} preferredPosition="above">
                                        <div
                                            onClick={() => {
                                                if (globalDirty) {
                                                    shakeSaveBar();
                                                }
                                            }}
                                            style={{ display: "inline-block" }}
                                        >
                                            <Button
                                                variant="primary"
                                                onClick={() => {
                                                    handleActivate(
                                                        !!getBoolean(bundleConfig.status),
                                                        bundleConfig?.form_id,
                                                    );
                                                }}
                                                loading={activatingBundle}
                                                disabled={
                                                    !bundleConfig?.form_id?.length ||
                                                    activatingBundle ||
                                                    loading ||
                                                    globalDirty ||
                                                    (bundleConfig?.form_id?.length > 0 &&
                                                        bundleConfig?.isProductPageVisible == true &&
                                                        bundleConfig?.product_bundle_id == "")
                                                }
                                            >
                                                {getBoolean(bundleConfig.status) ? "Unpublish" : "Publish"}
                                            </Button>
                                        </div>
                                    </Tooltip>
                                ) : (
                                    <Button
                                        variant="primary"
                                        onClick={() => {
                                            handleActivate(!!getBoolean(bundleConfig.status), bundleConfig?.form_id);
                                        }}
                                        loading={activatingBundle}
                                        disabled={
                                            !bundleConfig?.form_id?.length || activatingBundle || loading || globalDirty
                                        }
                                    >
                                        {getBoolean(bundleConfig.status) ? "Unpublish" : "Publish"}
                                    </Button>
                                )}

                                {showEnableCoreSnippetModal && (
                                    <ActivateSnippetModal
                                        setShowEnableCoreSnippetModal={setShowEnableCoreSnippetModal}
                                        onSnippetEnabled={() =>
                                            handleActivate(!!getBoolean(bundleConfig.status), bundleConfig?.form_id)
                                        }
                                    />
                                )}
                                {showEnableCoreSnippetModalForDraftPreview && (
                                    <ActivateSnippetModal
                                        setShowEnableCoreSnippetModal={setShowEnableCoreSnippetModalForDraftPreview}
                                        onSnippetEnabled={() => handleDraftPreview()}
                                    />
                                )}
                                {/* <PostPublishCard
                                    handlePreview={handlePreview}
                                    setShowPostPublishModal={setShowPostPublishModal}
                                    showPostPublishModal={showPostPublishModal}
                                    showPoweredByKefi={!!bundleConfig?.general_settings?.show_powered_by_kefi}
                                /> */}
                                {showStoreModal && (
                                    <ShowOnStoreModal
                                        open={showStoreModal}
                                        onClose={() => setShowStoreModal(false)}
                                        bundleType={bundleType}
                                        bundleLink={previewLink}
                                    />
                                )}

                                {/* Small screen action buttons  */}
                                <div className={styles.moreActionsIcon}>
                                    <Popover
                                        active={active}
                                        activator={
                                            <div onClick={() => setActive((active) => !active)}>
                                                <Icon source={MenuHorizontalIcon} tone="base"></Icon>
                                            </div>
                                        }
                                        autofocusTarget="first-node"
                                        onClose={() => setActive((active) => !active)}
                                    >
                                        <ActionList
                                            actionRole="menuitem"
                                            items={[
                                                {
                                                    prefix: <Icon source={DuplicateIcon} tone="base" />,
                                                    content: "Duplicate",
                                                    onAction: () => {
                                                        trackFormMenu({
                                                            cta: "Form Menu",
                                                            ctaType: "Duplicate Modal Triggered",
                                                            bundleType: bundleConfig?.bundle_type || "",
                                                        });
                                                        setDuplicateConfirmModal(true);
                                                    },
                                                    disabled:
                                                        !bundleConfig?.form_id?.length ||
                                                        duplicatingBundle ||
                                                        loading ||
                                                        globalDirty,
                                                },
                                                {
                                                    prefix: <Icon source={StatusActiveIcon} tone="base" />,
                                                    content: getBoolean(bundleConfig.status)
                                                        ? "Deactivate"
                                                        : "Activate",
                                                    disabled:
                                                        !bundleConfig?.form_id?.length ||
                                                        activatingBundle ||
                                                        loading ||
                                                        globalDirty,
                                                    onAction: () => {
                                                        handleActivate(
                                                            !!getBoolean(bundleConfig.status),
                                                            bundleConfig?.form_id,
                                                        );
                                                    },
                                                },
                                                {
                                                    prefix: <Icon source={ViewIcon} tone="base" />,
                                                    content: "Show on Store",
                                                    disabled:
                                                        !bundleConfig.status ||
                                                        !bundleConfig?.form_id?.length ||
                                                        loading ||
                                                        globalDirty,
                                                    onAction: () => handlePreview(),
                                                },
                                            ]}
                                        />
                                    </Popover>
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <RenderError submitErrors={globalErrors} />
                <BundleAsProductError bundleConfig={bundleConfig} />

                {!loading &&
                    bundleConfig?.form_id?.length > 0 &&
                    bundleConfig?.isProductPageVisible == true &&
                    bundleConfig?.product_bundle_id == "" && (
                        <div style={{ marginBottom: 14 }}>
                            <Banner title="This bundle may not work properly" tone="warning">
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                    <span>The bundle product was deleted from your Shopify store.</span>

                                    <Button
                                        variant="secondary"
                                        onClick={() => handleBundleSave({ src: "Restore Button" })}
                                        loading={savingBundle}
                                    >
                                        Restore
                                    </Button>
                                </div>
                            </Banner>
                        </div>
                    )}

                <div
                    className={styles.panels}
                    style={
                        loading && !onlyPreview
                            ? {}
                            : onlyPreview
                              ? {
                                    margin: "auto",
                                    display: "flex",
                                    justifyContent: "center",
                                    minWidth: "240px",
                                    maxWidth: "400px",
                                }
                              : forAiBundle
                                ? {
                                      padding: "1rem",
                                      background: "#f1f1f1",
                                  }
                                : {}
                    }
                >
                    {!onlyPreview && (
                        <div className={styles.leftSection}>
                            <Tabs
                                tabs={tabs}
                                selected={selected}
                                onSelect={handleTabChange}
                                disabled={disabledTabs || loading}
                            >
                                <div
                                    className={styles.selectedTabPanel}
                                    style={{
                                        pointerEvents: loading ? "none" : "all",
                                    }}
                                >
                                    {loading ? <FormLoadingSkeleton /> : renderForms[selected]}
                                </div>
                            </Tabs>

                            {/* <div className={styles.badgeContainer}>
                            <Badge progress="incomplete" tone="attention">
                                Coming Soon
                            </Badge>
                        </div> */}

                            {/* <div className={styles.comingSoonBadge}>
                            Coming Soon
                        </div> */}
                        </div>
                    )}
                    <div className={styles.rightSection} style={{ top: forAiBundle ? 69 : 64 }}>
                        <div className={styles.preview}>
                            {!onlyPreview && (
                                <>
                                    <div
                                        className={styles.previewWidgetTitle}
                                        style={{
                                            color: loading ? "#b5b5b5" : "#4a4a4a",
                                        }}
                                    >
                                        <div
                                            style={{
                                                zoom: 0.9,
                                            }}
                                        >
                                            <ButtonGroup variant="segmented">
                                                <Button
                                                    pressed={!inspectorMode}
                                                    onClick={() => {
                                                        if (inspectorMode) {
                                                            handleInspectorToggle();
                                                        }
                                                    }}
                                                    disabled={savingBundle || activatingBundle || loading}
                                                >
                                                    Preview
                                                </Button>

                                                <Button
                                                    pressed={inspectorMode}
                                                    onClick={() => {
                                                        if (!inspectorMode) {
                                                            handleInspectorToggle();
                                                        }
                                                    }}
                                                    disabled={savingBundle || activatingBundle || loading}
                                                    children={
                                                        <>
                                                            <span className={styles.inspectorModeToggleWrapper}>
                                                                Design Editor
                                                                <Tooltip
                                                                    width="wide"
                                                                    preferredPosition="above"
                                                                    content={
                                                                        <div className={styles.tooltipContent}>
                                                                            <div className={styles.mainTooltipText}>
                                                                                <span className={styles.shortcut}>
                                                                                    To edit styles:
                                                                                </span>{" "}
                                                                                Click any element.
                                                                            </div>
                                                                            <div className={styles.tooltipText}>
                                                                                Tip: Hold{" "}
                                                                                <span
                                                                                    className={styles.shortcut}
                                                                                    style={{
                                                                                        display: "inline-flex",
                                                                                        alignItems: "center",
                                                                                        gap: "2px",
                                                                                    }}
                                                                                >
                                                                                    {platform === "Mac" ? (
                                                                                        <MdOutlineKeyboardCommandKey
                                                                                            size={13}
                                                                                            style={{
                                                                                                position: "relative",
                                                                                                top: "2px",
                                                                                            }}
                                                                                        />
                                                                                    ) : (
                                                                                        "Ctrl"
                                                                                    )}{" "}
                                                                                </span>{" "}
                                                                                <span className={styles.shortcut}>
                                                                                    {" "}
                                                                                    + Click
                                                                                </span>{" "}
                                                                                to interact with the element normally
                                                                                without leaving Editor Mode.
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                >
                                                                    <span className={styles.infoIcon}>
                                                                        <InfoIconOverride size={14} />
                                                                    </span>
                                                                </Tooltip>
                                                            </span>
                                                        </>
                                                    }
                                                />
                                            </ButtonGroup>
                                        </div>

                                        {inspectorMode &&
                                            bundleType === "volume" &&
                                            (bundleConfig.products.length >= 1 ||
                                                // @ts-expect-error hack
                                                bundleConfig?.volume_product_selection != "specific") && (
                                                <Button
                                                    onClick={() => setOpenVolumeTemplateModal(true)}
                                                    variant="plain"
                                                    disabled={savingBundle || activatingBundle || loading}
                                                >
                                                    Change Template
                                                </Button>
                                            )}
                                        {inspectorMode &&
                                            bundleType === "standard" &&
                                            bundleConfig.products.length >= 1 && (
                                                <Button
                                                    onClick={() => setOpenStandardTemplateModal(true)}
                                                    variant="plain"
                                                    disabled={savingBundle || activatingBundle || loading}
                                                >
                                                    Change Template
                                                </Button>
                                            )}
                                        {inspectorMode &&
                                            bundleType === "bxgy" &&
                                            bundleConfig.products.length >= 1 && (
                                                <Button
                                                    onClick={() => setOpenBXGYTemplateModal(true)}
                                                    variant="plain"
                                                    disabled={savingBundle || activatingBundle || loading}
                                                >
                                                    Change Template
                                                </Button>
                                            )}
                                        {/* {inspectorMode &&
                                            bundleType === BundleTypes.FBT &&
                                            "selected_template_fbt" in bundleConfig &&
                                            bundleConfig?.selected_template_fbt !== AvailableFBTTemplates.HORIZONTAL &&
                                            (("fbt_product_selection" in bundleConfig &&
                                                bundleConfig?.fbt_product_selection == "all") ||
                                                bundleConfig.products.length >= 1) && (
                                                <span
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                        alignItems: "center",
                                                        gap: 5,
                                                        zoom: "0.9",
                                                    }}
                                                >
                                                    <Button
                                                        onClick={() => setOpenFBTTemplateModal(true)}
                                                        variant="plain"
                                                        disabled={savingBundle || activatingBundle || loading}
                                                    >
                                                        Change Template
                                                    </Button>
                                                </span>
                                            )} */}

                                        {bundleType === BundleTypes.FBT &&
                                            (("fbt_product_selection" in bundleConfig &&
                                                bundleConfig?.fbt_product_selection === "all") ||
                                                ("manual_product_scope" in bundleConfig &&
                                                    (bundleConfig as any)?.manual_product_scope === "all") ||
                                                bundleConfig.products.length >= 1) &&
                                            "selected_template_fbt" in bundleConfig && (
                                                <span
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "end",
                                                        alignItems: "center",
                                                        gap: 10,
                                                        zoom: "0.9",
                                                    }}
                                                >
                                                    {/* Change Template button */}
                                                    {inspectorMode && (
                                                        <Button
                                                            onClick={() => setOpenFBTTemplateModal(true)}
                                                            variant="plain"
                                                            disabled={savingBundle || activatingBundle || loading}
                                                        >
                                                            Change Template
                                                        </Button>
                                                    )}

                                                    {/* Mobile/Desktop view icons */}
                                                    {!inspectorMode && (
                                                        <span
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: 10,
                                                            }}
                                                        >
                                                            <span
                                                                onClick={() => setSelectedPreviewView(1)}
                                                                style={{
                                                                    cursor: "pointer",
                                                                    backgroundColor:
                                                                        selectedPreviewView === 1
                                                                            ? "#dddddd"
                                                                            : "#ffffff",
                                                                    borderRadius: "6px",
                                                                    padding: "2px",
                                                                }}
                                                            >
                                                                <Tooltip content="Mobile View">
                                                                    <Icon
                                                                        source={MobileIcon}
                                                                        tone={loading ? "subdued" : "base"}
                                                                    />
                                                                </Tooltip>
                                                            </span>

                                                            <span
                                                                onClick={() => setSelectedPreviewView(2)}
                                                                style={{
                                                                    cursor: "pointer",
                                                                    backgroundColor:
                                                                        selectedPreviewView === 2
                                                                            ? "#dddddd"
                                                                            : "#ffffff",
                                                                    borderRadius: "6px",
                                                                    padding: "2px",
                                                                }}
                                                            >
                                                                <Tooltip content="Desktop View">
                                                                    <Icon
                                                                        source={DesktopIcon}
                                                                        tone={loading ? "subdued" : "base"}
                                                                    />
                                                                </Tooltip>
                                                            </span>
                                                        </span>
                                                    )}
                                                </span>
                                            )}
                                    </div>
                                </>
                            )}
                            {loading || loadingCollectionProducts ? (
                                <PreviewLoadingSkeleton />
                            ) : (
                                <>
                                    {bundleType === "volume" &&
                                        // @ts-expect-error hack
                                        (bundleConfig?.volume_product_selection == "specific" ||
                                            bundleConfig?.volume_product_selection == "collection") &&
                                        (bundleConfig.products.length > 1 || collectionProducts.length > 1) && (
                                            <div
                                                style={{
                                                    marginBottom: "10px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "12px",
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: "12px",
                                                        color: "#4a4a4a",
                                                    }}
                                                >
                                                    Product:{" "}
                                                </span>
                                                <select
                                                    className={styles.select}
                                                    name={"widget_selector"}
                                                    onChange={(e) =>
                                                        setCurrentActiveProduct &&
                                                        setCurrentActiveProduct(e.target.value)
                                                    }
                                                    value={currentActiveProduct}
                                                >
                                                    {bundleConfig?.volume_product_selection === "specific"
                                                        ? bundleConfig.products.map((sp) => (
                                                              <option key={sp.id} value={sp.id}>
                                                                  {sp.title}
                                                              </option>
                                                          ))
                                                        : collectionProducts.map((sp) => (
                                                              <option key={sp.id} value={sp.id}>
                                                                  {sp.title}
                                                              </option>
                                                          ))}
                                                </select>
                                            </div>
                                        )}
                                    {renderPreview}
                                </>
                            )}
                        </div>
                        {!loading && <CalloutNudgeBanner />}
                        {!onlyPreview && !loading && <SuggestFeature bundleType={bundleType} />}
                    </div>
                </div>
                <CustomModal
                    title={"Duplicate Bundle"}
                    open={duplicateConfirmModal}
                    loading={duplicateBundleLoading}
                    onClose={() => {
                        setDuplicateConfirmModal(false);
                    }}
                    primaryAction={{
                        content: "Duplicate",
                        disabled: !newBundleTitle || !!duplicateErr.length || duplicateBundleLoading,
                        onAction: () => handleDuplicate(newBundleTitle),
                    }}
                    secondaryActions={[
                        {
                            content: "Cancel",
                            onAction: () => {
                                trackFormMenu({
                                    cta: "Form Menu",
                                    ctaType: "Duplicate Modal Closed",
                                    bundleType: bundleConfig?.bundle_type || "",
                                });
                                setDuplicateConfirmModal(false);
                            },
                        },
                    ]}
                >
                    <FormLayout>
                        <TextField
                            label="Title"
                            placeholder="bundle title"
                            autoComplete=""
                            value={newBundleTitle}
                            onChange={(val) => {
                                setNewBundleTitle(val);
                            }}
                            error={duplicateErr}
                        />
                    </FormLayout>
                </CustomModal>

                {openVolumeTemplateModal && (
                    <VolumeBundleTemplate
                        openVolumeTemplateModal={openVolumeTemplateModal}
                        setOpenVolumeTemplateModal={setOpenVolumeTemplateModal}
                        bundleConfig={{
                            ...bundleConfig,
                            products: ((bundleConfig as VolumeConfigInterface)?.volume_product_selection ===
                            "collection"
                                ? collectionProducts
                                : bundleConfig.products
                            ).filter((p) => p.id == currentActiveProduct),
                        }}
                        dispatchBundleConfig={dispatchBundleConfig}
                        standAlone={false}
                        forAiBundle={forAiBundle}
                    />
                )}

                {openStandardTemplateModal && (
                    <StandardBundleTemplate
                        openStandardTemplateModal={openStandardTemplateModal}
                        setOpenStandardTemplateModal={setOpenStandardTemplateModal}
                        bundleConfig={bundleConfig}
                        dispatchBundleConfig={dispatchBundleConfig}
                        standAlone={false}
                        forAiBundle={forAiBundle}
                    />
                )}

                {openBXGYTemplateModal && (
                    <BXGYBundleTemplate
                        setOpenBXGYTemplateModal={setOpenBXGYTemplateModal}
                        bundleConfig={bundleConfig}
                        dispatchBundleConfig={dispatchBundleConfig}
                        standAlone={false}
                        forAiBundle={forAiBundle}
                    />
                )}

                {openFBTTemplateModal && (
                    <FBTBundleTemplate
                        setOpenFBTTemplateModal={setOpenFBTTemplateModal}
                        bundleConfig={bundleConfig}
                        dispatchBundleConfig={dispatchBundleConfig}
                        standAlone={false}
                    />
                )}

                {showLimitPopup && (
                    <LimitReachedPopup
                        setPopup={setShowLimitPopup}
                        isExhausted={isExhausted}
                        currentPlan={currentPlan}
                        currentOrders={currentOrders}
                    />
                )}
                <FBTModalPreviewer
                    bundleConfig={bundleConfig}
                    open={selectedPreviewView == 2}
                    onClose={() => {
                        setSelectedPreviewView(1);
                    }}
                />
                <SaveBar id="bundle-save-bar">
                    <button
                        variant="primary"
                        onClick={() => {
                            handleBundleSave({ src: "Top Bar" });
                        }}
                        disabled={savingBundle}
                    >
                        Save
                    </button>
                    <button
                        onClick={() => {
                            handleDiscard({ src: "Top Bar" });
                        }}
                        disabled={savingBundle}
                    >
                        Discard
                    </button>
                </SaveBar>
            </div>
        </div>
    );
};

export default FormPreviewWrapper;
